<template>
  <div v-if="items && items.length > 0">
    <div
      class="flex flex-wrap items-center justify-between gap-y-2 border-y px-6 py-1.5 text-sm/6 font-semibold text-neutral-900"
      :class="{
        'border-b-neutral-200 border-t-neutral-100 bg-neutral-50': variant === 'plain',
        'border-b-sky-200 border-t-sky-100 bg-sky-50': variant === 'info',
        'border-b-yellow-300 border-t-yellow-100 bg-yellow-50': variant === 'warn',
      }"
      v-if="title"
    >
      <h4>{{ title }}</h4>
      <div class="ml-4 flex min-w-fit flex-wrap items-start justify-start gap-4 print:hidden" v-if="viewAllTo">
        <router-link class="text-sm font-normal text-sky-500 hover:underline" :to="viewAllTo">View All</router-link>
      </div>
    </div>
    <ul role="list" class="divide-y divide-neutral-200">
      <li v-for="item in items" :key="item.id" class="group block last-of-type:rounded-b-md hover:bg-sky-100">
        <router-link :to="item.to" class="block">
          <div class="flex items-center px-4 py-4 sm:px-6">
            <div class="flex min-w-0 flex-1 items-center">
              <slot name="default" :item="item"> </slot>
            </div>
            <div>
              <ChevronRightIcon
                class="z-0 h-6 w-6 text-neutral-300 transition-transform ease-in group-hover:translate-x-1 group-hover:text-neutral-500"
                aria-hidden="true"
              />
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
// Note: When updating this description - you must also update the md file.

/** A list of entities that can be displayed in a landing card. */
export default { name: "LandingCardEntityList" };
</script>

<script setup lang="ts" generic="T extends LandingCardEntityBase">
import type { LandingCardEntityBase, LandingCardVariant } from "@/components/landing/landingCard";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import type { RouteLocationRaw } from "vue-router";

withDefaults(
  defineProps<{
    title?: string;
    items: T[] | undefined;
    variant?: LandingCardVariant;
    viewAllTo?: RouteLocationRaw;
  }>(),
  {
    variant: "plain",
  },
);
</script>
